<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col">
			<ng-select id="company" [items]="company_list" bindLabel="comp_name" bindValue="apptid" [clearable]="false"
				[multiple]="true" placeholder="Company*" formControlName="company" appearance="outline">
			</ng-select>
			<p *ngIf="showError('company')" class="text-danger">
				<span *ngIf="f.company.errors?.required">
					Required
				</span>
				<span *ngIf="f.company.errors?.incorrect">
					{{customError.company}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('name')}" id="name"
					formControlName="name" placeholder="">
				<label for="name">Branch Name*</label>
			</div>
			<p *ngIf="showError('name')" class="text-danger">
				<span *ngIf="f.name.errors?.required">
					Required
				</span>
				<span *ngIf="f.name.errors?.incorrect">
					{{customError.name}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('email')}" id="email"
					formControlName="email" placeholder="">
				<label for="email">Email Id*</label>
			</div>
			<p *ngIf="showError('email')" class="text-danger">
				<span *ngIf="f.email.errors?.required">
					Required
				</span>
				<span *ngIf="f.email.errors?.pattern">
					Invalid
				</span>
				<span *ngIf="f.email.errors?.incorrect">
					{{customError.email}}
				</span>
			</p>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<div class="w-50 float-start">
				<ng-select appendTo="body" [items]="countries" bindLabel="display" bindValue="dial_code"
					[clearable]="true" [multiple]="false" id="countryCode" formControlName="countryCode"
					name="countryCode" placeholder="Country Code" [appearance]="'outline'">
				</ng-select>
				<p *ngIf="showError('countryCode')" class="text-danger">
					<span *ngIf="f.countryCode.errors?.required">
						Required
					</span>
					<span *ngIf="f.countryCode.errors?.incorrect">
						{{customError.countryCode}}
					</span>
				</p>
			</div>
			<div class="w-50 float-start">
				<div class="form-floating">
					<input class="form-control" [ngClass]="{'is-invalid':showError('phone_no')}" id="phone_no"
						formControlName="phone_no" placeholder="">
					<label for="phone_no">Phone No.</label>
				</div>
				<p *ngIf="showError('phone_no')" class="text-danger">
					<span *ngIf="f.phone_no.errors?.required">
						Required
					</span>
					<span *ngIf="f.phone_no.errors?.pattern">
						Invalid
					</span>
					<span *ngIf="f.phone_no.errors?.incorrect">
						{{customError.phone_no}}
					</span>
				</p>
			</div>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col">
			<div class="form-floating">
				<textarea class="form-control" [ngClass]="{'is-invalid':showError('address')}" id="address"
					formControlName="address" placeholder=""></textarea>
				<label for="address">Address*</label>
			</div>
			<p *ngIf="showError('address')" class="text-danger">
				<span *ngIf="f.address.errors?.required">
					Required
				</span>
				<span *ngIf="f.address.errors?.incorrect">
					{{customError.address}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
			<label>Two Factor Auth:</label>
			<br />
			<ng-toggle formControlName="enable2fa" [color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
				[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
				[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
				[labels]="{'unchecked': 'Disable','checked': 'Enable'}" [width]="100"></ng-toggle>
		</div>
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" *ngIf="!uId">
			<div class="form-floating">
				<input class="form-control" type="password" [ngClass]="{'is-invalid':showError('password')}"
					id="password" formControlName="password" placeholder="">
				<label for="password">Password*</label>
			</div>
			<div *ngIf="showError('password')" class="text-danger">
				<p *ngIf="f.password.errors?.required">
					Please enter password.
				</p>
				<p [ngClass]="f.password.errors?.minlengtherror?'text-danger':'text-success'">
					Must be atleast 8 characters long.
				</p>
				<p [ngClass]="f.password.errors?.specialcharerror?'text-danger':'text-success'">
					Must have atleast 1 special character.
				</p>
				<p [ngClass]="f.password.errors?.uppercaseerror?'text-danger':'text-success'">
					Must have atleast 1 upper case character.
				</p>
				<p [ngClass]="f.password.errors?.lowercaseerror?'text-danger':'text-success'">
					Must have atleast 1 lower case character.
				</p>
				<p [ngClass]="f.password.errors?.digiterror?'text-danger':'text-success'">
					Must have atleast 1 digit.
				</p>
				<p *ngIf="f.password.errors?.incorrect">
					{{customError.password}}
				</p>
			</div>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-primary me-1" [disabled]="showLoader">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>